export const ROW_PAGE_STATUS_LOADING = 'ROW_PAGE_STATUS_LOADING';
export const ROW_PAGE_STATUS_INIT_FAILED = 'ROW_PAGE_STATUS_INIT_FAILED';
export const ROW_PAGE_STATUS_NO_ADDRESS = 'ROW_PAGE_STATUS_NO_ADDRESS';
export const ROW_PAGE_STATUS_OK = 'ROW_PAGE_STATUS_OK';
export const ROW_STATUS_LOADING = 'ROW_STATUS_LOADING';
export const ROW_STATUS_API_ERROR = 'ROW_STATUS_API_ERROR';
export const ROW_STATUS_OK = 'ROW_STATUS_OK';
